import { module } from 'angular';

import { CustomFilter, DomainFilter, IndicatorFilter, SkillFilter } from './';
import { default as skillViewFilterServiceName, SkillViewFilterService } from './filter.service';

export default module('hypervision.skill-view.custom.filter', [CustomFilter, DomainFilter, IndicatorFilter, SkillFilter]).service(
  skillViewFilterServiceName,
  SkillViewFilterService
).name;
